import React from "react";
import { motion } from "framer-motion";

const rows = [
  { day: "LUNI", jp: "月", karate: "18:00 — 19:30", mma: "20:00 — 21:30" },
  { day: "MIERCURI", jp: "水", karate: "18:00 — 19:30", mma: "20:00 — 21:30" },
  { day: "JOI", jp: "木", karate: "18:00 — 19:30", mma: "20:00 — 21:30" },
];

const rowV = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

const ScheduleGrid = () => {
  return (
    <section
      id="program"
      className="section border-t border-[rgba(242,235,229,0.1)]"
      data-testid="schedule-section"
    >
      <div className="container-brutal">
        {/* Header */}
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <span className="eyebrow">§ 02 / Program</span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="section-title"
            >
              Trei zile.<br />
              <span className="text-[#D91604]">Două</span> discipline.
            </motion.h2>
            <p className="editorial-lead mt-6 max-w-xl text-[#8a8a8a]">
              Antrenamentele se desfășoară în sala de la Blocul 5, Str. Victoriei 17.
              Rezervarea unei ședințe de probă este gratuită.
            </p>
          </div>
        </div>

        {/* Table */}
        <div className="border border-[rgba(242,235,229,0.1)]" data-testid="schedule-grid">
          {/* Column headers */}
          <div className="hidden md:grid grid-cols-12 border-b border-[rgba(242,235,229,0.1)] bg-[#0a0a0a]">
            <div className="col-span-3 brutal-cell !border-0 border-r border-[rgba(242,235,229,0.1)]">
              <div className="eyebrow">Ziua</div>
            </div>
            <div className="col-span-1 brutal-cell !border-0 border-r border-[rgba(242,235,229,0.1)]">
              <div className="eyebrow">JP</div>
            </div>
            <div className="col-span-4 brutal-cell !border-0 border-r border-[rgba(242,235,229,0.1)]">
              <div className="eyebrow">Karate Shotokan</div>
            </div>
            <div className="col-span-4 brutal-cell !border-0">
              <div className="eyebrow">MMA</div>
            </div>
          </div>

          {/* Rows */}
          {rows.map((r, i) => (
            <motion.div
              key={r.day}
              custom={i}
              variants={rowV}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="grid grid-cols-12 group border-b border-[rgba(242,235,229,0.1)] last:border-b-0"
              data-testid={`schedule-row-${r.day.toLowerCase()}`}
            >
              <div className="col-span-6 md:col-span-3 flex items-center gap-4 px-6 py-8 md:py-10 border-r border-[rgba(242,235,229,0.1)]">
                <span className="font-anton text-3xl md:text-5xl leading-none cell-day">{r.day}</span>
              </div>
              <div className="col-span-6 md:col-span-1 flex items-center px-6 py-8 md:py-10 border-r border-[rgba(242,235,229,0.1)]">
                <span className="font-jp text-3xl text-[#8a8a8a]">{r.jp}</span>
              </div>
              <div className="col-span-6 md:col-span-4 flex flex-col justify-center px-6 py-8 md:py-10 border-r border-[rgba(242,235,229,0.1)] transition-colors group-hover:bg-[#D91604] group-hover:text-[#050505]">
                <div className="eyebrow group-hover:text-[#050505]/80">Karate</div>
                <div className="font-anton text-3xl md:text-4xl mt-1 cell-time">{r.karate}</div>
              </div>
              <div className="col-span-6 md:col-span-4 flex flex-col justify-center px-6 py-8 md:py-10">
                <div className="eyebrow">MMA</div>
                <div className="font-anton text-3xl md:text-4xl mt-1 cell-time">{r.mma}</div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Footnote */}
        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-sm text-[#8a8a8a]">
            <span className="dot-red" /> Marți & Vineri — antrenamente private (la cerere).
          </p>
          <a
            href="tel:0738711661"
            data-testid="schedule-cta"
            className="font-anton tracking-widest text-sm uppercase link-underline"
          >
            Rezervă loc · 0738 711 661
          </a>
        </div>
      </div>
    </section>
  );
};

export default ScheduleGrid;
